module.exports = __webpack_public_path__ + "static/media/lg20.30ebedb7.png";